import { render, staticRenderFns } from "./FormOpenTicket.vue?vue&type=template&id=50814c10"
import script from "./FormOpenTicket.vue?vue&type=script&lang=js"
export * from "./FormOpenTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports